import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import VehiclesSection from '../VehiclesSection';
import AddVehicleModal from '../AddVehicleModal';
import { useCarContext } from '../../../contexts/CarContext';

const DriverDashboard = () => {
    const { t } = useTranslation();

    // Dummy user data
    const userData = {
        name: "John Doe",
        email: "john.doe@example.com",
        joinDate: "Jan 2023",
        license: "DL-12345678",
        profileImage: "https://randomuser.me/api/portraits/men/32.jpg"
    };

    // Get cars data from context
    const { cars, fetchCars } = useCarContext();

    // State for add car modal
    const [showAddCarModal, setShowAddCarModal] = useState(false);

    const [selectedCar, setSelectedCar] = useState(null);
    const [isCardClicked, setIsCardClicked] = useState(false);

    // Update selectedCar when cars data is loaded (only on initial load)
    useEffect(() => {
        if (cars.length > 0 && !selectedCar && !isCardClicked) {
            setSelectedCar(cars[0]);
            setIsCardClicked(true);
        }
    }, [cars]); // Remove selectedCar from dependencies to prevent auto-reset

    return (
        <div className="">
            <VehiclesSection
                cars={cars}
                setShowAddCarModal={setShowAddCarModal}
                selectedCar={selectedCar}
                setSelectedCar={setSelectedCar}
                isCardClicked={isCardClicked}
                setIsCardClicked={setIsCardClicked}
                onCarsChanged={fetchCars} // Pass refresh function
            />
            <AddVehicleModal
                showAddCarModal={showAddCarModal}
                setShowAddCarModal={setShowAddCarModal}
                onCarsChanged={fetchCars} // Pass refresh function
            />
        </div>
    );
}
export default DriverDashboard;